export default __webpack_public_path__ + "static/media/add-points-icon.aaaa24d3.svg";